import { createAction, props } from '@ngrx/store';

import { PickId } from '../../core/picks/pick-id';
import { BetslipTypesActions } from '../types/actions';
import { ISingleBetPickState } from './state';

export enum stakeSource {
    QuickBet,
    Betslip,
}
export default class BetslipSingleBetActions {
    static readonly ACTION_SCHEMA = `${BetslipTypesActions.ACTION_SCHEMA}/single-bet`;

    private static readonly ADD_PICK = `${BetslipSingleBetActions.ACTION_SCHEMA}/ADD_PICK`;
    private static readonly REQUEST_REMOVE_PICK = `${BetslipSingleBetActions.ACTION_SCHEMA}/REQUEST_REMOVE_PICK`;
    private static readonly REMOVE_PICK = `${BetslipSingleBetActions.ACTION_SCHEMA}/REMOVE_PICK`;
    private static readonly UPDATE_PICK_ORDER = `${BetslipSingleBetActions.ACTION_SCHEMA}/UPDATE_PICK_ORDER`;
    private static readonly SET_SINGLE_BET_STAKE = `${BetslipSingleBetActions.ACTION_SCHEMA}/SET_SINGLE_BET_STAKE`;
    private static readonly SET_SINGLE_BET_PICK_STAKE = `${BetslipSingleBetActions.ACTION_SCHEMA}/SET_SINGLE_BET_PICK_STAKE`;
    private static readonly SET_SINGLE_BET_PICK_REWARD_TOKEN = `${BetslipSingleBetActions.ACTION_SCHEMA}/SET_SINGLE_BET_PICK_REWARD_TOKEN`;
    private static readonly REMOVE_ALL_SINGLE_BET_PICK_REWARD_TOKENS = `${BetslipSingleBetActions.ACTION_SCHEMA}/REMOVE_ALL_SINGLE_BET_PICK_REWARD_TOKENS`;
    private static readonly TOGGLE_SINGLE_BET_PICK_EACH_WAY = `${BetslipSingleBetActions.ACTION_SCHEMA}/TOGGLE_SINGLE_BET_PICK_EACH_WAY`;
    private static readonly SET_SINGLE_BET_PICK_EACH_WAY = `${BetslipSingleBetActions.ACTION_SCHEMA}/SET_SINGLE_BET_PICK_EACH_WAY`;
    private static readonly SET_SINGLE_BET_PICKS_EACH_WAY = `${BetslipSingleBetActions.ACTION_SCHEMA}/SET_SINGLE_BET_PICKS_EACH_WAY`;
    private static readonly TOGGLE_SINGLE_BET_PICK = `${BetslipSingleBetActions.ACTION_SCHEMA}/TOGGLE_SINGLE_BET_PICK`;
    private static readonly ADD_PICK_WITH_NEW_PICKID = `${BetslipSingleBetActions.ACTION_SCHEMA}/ADD_PICK_WITH_NEW_PICKID`;

    static setSingleBetStake = createAction(
        BetslipSingleBetActions.SET_SINGLE_BET_STAKE,
        props<{ stake: number | null; silent?: boolean; stakeStr?: string }>(),
    );

    static setSingleBetPickStake = createAction(
        BetslipSingleBetActions.SET_SINGLE_BET_PICK_STAKE,
        props<{ pickId: string; stake: number | null; silent?: boolean; stakeStr?: string; stakeSource?: stakeSource }>(),
    );

    static setSingleBetPickRewardToken = createAction(
        BetslipSingleBetActions.SET_SINGLE_BET_PICK_REWARD_TOKEN,
        props<{ pickId: string; rewardTokenId: string | null }>(),
    );

    static removeAllSingleBetPickRewardTokens = createAction(BetslipSingleBetActions.REMOVE_ALL_SINGLE_BET_PICK_REWARD_TOKENS);

    static toggleSingleBetPickEachWay = createAction(BetslipSingleBetActions.TOGGLE_SINGLE_BET_PICK_EACH_WAY, props<{ pickId: PickId }>());

    /**
     * Invoked from the epic when golf pick is added. it sets the each way status automatically
     *
     * @param index pick index
     * @param isEachWay isEachWay value.
     */
    static setSingleBetPickEachWay = createAction(
        BetslipSingleBetActions.SET_SINGLE_BET_PICK_EACH_WAY,
        props<{ pickId: PickId; isEachWay: boolean }>(),
    );

    static setSingleBetPicksEachWay = createAction(
        BetslipSingleBetActions.SET_SINGLE_BET_PICKS_EACH_WAY,
        props<{ pickIds: PickId[]; isEachWay: boolean }>(),
    );

    static toggleSingleBetPick = createAction(BetslipSingleBetActions.TOGGLE_SINGLE_BET_PICK, props<{ pickId: PickId }>());
    static addPick = createAction(BetslipSingleBetActions.ADD_PICK, props<{ pickId: string; pickState: Partial<ISingleBetPickState> }>());
    static updateOrder = createAction(BetslipSingleBetActions.UPDATE_PICK_ORDER, props<{ pickId: string; order: number }>());
    static requestRemovePick = createAction(BetslipSingleBetActions.REQUEST_REMOVE_PICK, props<{ pickId: string }>());
    static removePick = createAction(BetslipSingleBetActions.REMOVE_PICK, props<{ pickId: string }>());
    static addPickWithNewPickId = createAction(BetslipSingleBetActions.ADD_PICK_WITH_NEW_PICKID);
}
